var _rect, _rect2, _rect3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRelationship(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.07227,
    y: 1.44678,
    width: 5.85714,
    height: 5.85714,
    rx: 0.5,
    stroke: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 15.1611,
    width: 5.85714,
    height: 5.85714,
    rx: 0.5,
    stroke: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 17.6426,
    y: 15.1611,
    width: 5.85714,
    height: 5.85714,
    rx: 0.5,
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9992 6.94678V11.2325M11.9992 11.2325H19.5706C20.1229 11.2325 20.5706 11.6802 20.5706 12.2325V15.5182M11.9992 11.2325H4.42773C3.87545 11.2325 3.42773 11.6802 3.42773 12.2325V15.5182",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelationship);
export default __webpack_public_path__ + "static/media/relationship.2e0c0ef73a3f48bb7144351d7336205e.svg";
export { ForwardRef as ReactComponent };